var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.184 3c.739 0 1.363.556 1.46 1.302l.345 2.625c.056.428-.073.86-.352 1.186-.28.325-.684.512-1.11.512H6.37v2.625h2.21v-.75h-.184a.186.186 0 0 1-.184-.188v-.75c0-.103.082-.187.184-.187h.553v-.75h-.553a.186.186 0 0 1-.184-.188v-.75c0-.103.082-.187.184-.187h4.052c.102 0 .185.084.185.188v.75a.186.186 0 0 1-.185.187h-.552v.75h.552c.102 0 .185.084.185.188v.75a.186.186 0 0 1-.185.187h-.184v.75h.369c.203 0 .368.168.368.375a.372.372 0 0 1-.368.375H4.527a.372.372 0 0 1-.368-.375c0-.207.165-.375.368-.375h1.105V8.625h-.158c-.425 0-.83-.187-1.11-.512a1.518 1.518 0 0 1-.351-1.186l.344-2.625A1.483 1.483 0 0 1 5.817 3h.367Zm5.71 8.25v-.75H8.949v.75h2.947Zm-.368-2.625h-2.21v.75h2.21v-.75Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.31e909e73a98e1b334ec511efaf1bd0a.svg";
export { ForwardRef as ReactComponent };